module.exports = __webpack_public_path__ + "static/img/1.ea248498.png";